import { GLOBAL_ACTION } from "../constant/GlobalConstant";

export const handleChange = (data) => async (dispatch) => {
  dispatch({
    type: GLOBAL_ACTION,
    payload: data,
  });
};
